/*
 * Lioninox - Plazo de entrega cuando la cantidad del carrito supera el stock.
 *
 * Garantiza que cada linea del carrito lleve su fecha de entrega. La propiedad la escribe
 * la app Estimated Delivery Date con un nombre distinto por idioma ("Livraison entre",
 * "Lieferung zwischen", "Consegna tra"...), asi que se localiza por el formato del valor
 * (dd/mm/aa <conector> dd/mm/aa) y se conserva su nombre y su conector:
 * - Si una variante con "vender sin existencias" tiene en el carrito mas unidades
 *   que stock disponible, sustituye la fecha por el plazo de la regla sin stock (express o camion segun peso, normal o
 *   temporada alta segun fecha). La fecha original se guarda en la propiedad
 *   oculta "_livraison_origine" y se restaura si la cantidad vuelve a caber.
 * - Si la linea llega sin fecha (p. ej. anadida desde una coleccion), la crea con el nombre
 *   y el conector del idioma del cliente (configuracion "etiquetas") y la marca con la
 *   propiedad oculta "_livraison_calculee" para recalcularla si cambia la cantidad.
 * Configuracion: snippets/lioninox-plazos-config.liquid.
 * Si la configuracion no se puede leer, usa el texto de
 * snippets/lioninox-delai-a-confirmer.liquid.
 *
 * Depende de: sections/lioninox-cart-stock.liquid
 */
(function () {
  'use strict';
  if (window.__lioninoxCartStock) return;
  window.__lioninoxCartStock = true;

  var PROP_DEFECTO = 'Livraison entre';
  var CONECTOR_DEFECTO = 'et';
  // dd/mm/aa <conector> dd/mm/aa
  var FECHAS_RE = /^\s*(\d{2}\/\d{2}\/\d{2})\s+(\S+)\s+(\d{2}\/\d{2}\/\d{2})\s*$/;
  var BACKUP = '_livraison_origine';
  var CALC = '_livraison_calculee';
  var SECTION = 'lioninox-cart-stock';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?$/;
  var nativeFetch = window.fetch.bind(window);

  var goingToCheckout = false;

  function log() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[lioninox-cart-stock]');
    console.warn.apply(console, args);
  }

  // ---------- Calculo de plazos ----------

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  // Fecha y hora actuales en la zona de la configuracion.
  function nowIn(zone) {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return {
      date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day)),
      hour: +parts.hour + (+parts.minute) / 60
    };
  }

  function iso(d) {
    return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate());
  }

  function addDays(d, n) {
    return new Date(d.getTime() + n * 86400000);
  }

  function isWorkingDay(d, festivos) {
    var wd = d.getUTCDay();
    return wd !== 0 && wd !== 6 && festivos.indexOf(iso(d)) === -1;
  }

  function nextWorkingDay(d, festivos) {
    do { d = addDays(d, 1); } while (!isWorkingDay(d, festivos));
    return d;
  }

  function addWorkingDays(d, n, festivos) {
    for (var i = 0; i < n; i++) d = nextWorkingDay(d, festivos);
    return d;
  }

  function isHighSeason(d, ranges) {
    var md = iso(d).slice(5);
    return ranges.some(function (r) {
      return r[0] <= r[1] ? (md >= r[0] && md <= r[1]) : (md >= r[0] || md <= r[1]);
    });
  }

  function formatDate(d) {
    return pad(d.getUTCDate()) + '/' + pad(d.getUTCMonth() + 1) + '/' + String(d.getUTCFullYear()).slice(2);
  }

  // Texto "dd/mm/aa <conector> dd/mm/aa" con el mismo criterio que la app.
  // clave: 'en_stock' o 'sin_stock'
  function plazo(clave, pesoG, cfg, now, conector) {
    var festivos = cfg.festivos || [];
    var base = now.date;
    if (!isWorkingDay(base, festivos) || now.hour >= cfg.hora_corte) {
      base = nextWorkingDay(base, festivos);
    }
    var tipo = (pesoG / 1000) < cfg.peso_max_express_kg ? cfg.express : cfg.camion;
    var dias = clave === 'en_stock'
      ? tipo.en_stock
      : (isHighSeason(now.date, cfg.temporada_alta) ? tipo.temporada_alta : tipo.normal);
    return formatDate(addWorkingDays(base, dias[0], festivos)) + ' ' + conector + ' ' +
      formatDate(addWorkingDays(base, dias[1], festivos));
  }

  // ---------- Carrito ----------

  function request(url, opts) {
    opts = opts || {};
    opts.credentials = 'same-origin';
    opts.headers = Object.assign({ 'X-Requested-With': 'XMLHttpRequest' }, opts.headers || {});
    return nativeFetch(url, opts).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status + ' ' + url);
      return r.json();
    });
  }

  function getCart() {
    return request(ROOT + 'cart.js');
  }

  function getStock() {
    return request(ROOT + '?sections=' + SECTION).then(function (json) {
      var doc = new DOMParser().parseFromString(json[SECTION] || '', 'text/html');
      var el = doc.getElementById('lioninox-cart-stock-data');
      if (!el) throw new Error('la seccion no devuelve datos');
      var data = JSON.parse(el.textContent);
      data.config = null;
      var cfgEl = doc.getElementById('lioninox-plazos-config');
      try {
        if (cfgEl) data.config = JSON.parse(cfgEl.textContent);
      } catch (e) {
        log('configuracion de plazos no valida, se usa el texto por defecto', e);
      }
      return data;
    });
  }

  function valorPlazo(clave, s, data, now, conector) {
    if (data.config) {
      try {
        return plazo(clave, s.peso_g, data.config, now, conector);
      } catch (e) {
        log('error calculando el plazo, se usa el texto por defecto', e);
      }
    }
    return data.texto;
  }

  // Localiza la propiedad de fecha de la linea, sea cual sea su nombre e idioma.
  function buscarFecha(props) {
    for (var k in props) {
      if (!Object.prototype.hasOwnProperty.call(props, k)) continue;
      if (k.charAt(0) === '_') continue;
      var m = FECHAS_RE.exec(String(props[k]));
      if (m) return { nombre: k, conector: m[2] };
    }
    return null;
  }

  // Nombre y conector del idioma del cliente, segun la configuracion.
  function etiquetaIdioma(data) {
    var etiquetas = (data.config && data.config.etiquetas) || {};
    var locale = data.locale || '';
    return etiquetas[locale] || etiquetas[locale.split('-')[0]] || null;
  }

  // Devuelve el siguiente cambio a aplicar en el carrito, o null si no hay nada que hacer.
  function nextChange(cart, data, now) {
    var total = {};
    var stock = {};
    data.lineas.forEach(function (l) {
      total[l.variant_id] = (total[l.variant_id] || 0) + l.cantidad;
      stock[l.variant_id] = l;
    });

    var par = etiquetaIdioma(data);

    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var s = stock[item.variant_id];
      if (!s) continue;

      var props = Object.assign({}, item.properties || {});
      var calculada = props[CALC] === '1';
      var fecha = buscarFecha(props);
      var excede = s.gestion === 'shopify' && s.politica === 'continue' && total[item.variant_id] > s.stock;
      var change = { line: i + 1, quantity: item.quantity, properties: props };

      // Si la fecha la escribimos nosotros, se rehace con el idioma actual del cliente.
      var nombre, conector;
      if (calculada && par) {
        nombre = par[0];
        conector = par[1];
      } else if (fecha) {
        nombre = fecha.nombre;
        conector = fecha.conector;
      } else if (par) {
        nombre = par[0];
        conector = par[1];
      } else {
        nombre = PROP_DEFECTO;
        conector = CONECTOR_DEFECTO;
      }
      var sobra = fecha && fecha.nombre !== nombre ? fecha.nombre : null;
      var valor;

      if (excede) {
        valor = valorPlazo('sin_stock', s, data, now, conector);
        if (!sobra && props[nombre] === valor) continue;
        if (fecha && !calculada && !props[BACKUP]) props[BACKUP] = props[fecha.nombre];
        if (!fecha && !props[BACKUP]) props[CALC] = '1';
        if (sobra) delete props[sobra];
        props[nombre] = valor;
        return change;
      }

      if (props[BACKUP]) {
        if (sobra) delete props[sobra];
        props[nombre] = props[BACKUP];
        delete props[BACKUP];
        delete props[CALC];
        return change;
      }

      if (!fecha || calculada) {
        valor = valorPlazo('en_stock', s, data, now, conector);
        if (!sobra && props[nombre] === valor) continue;
        if (sobra) delete props[sobra];
        props[nombre] = valor;
        props[CALC] = '1';
        return change;
      }
    }
    return null;
  }

  function refreshUI() {
    if (goingToCheckout) return;
    if (/\/cart\/?$/.test(location.pathname)) {
      location.reload();
      return;
    }
    var miniCart = document.querySelector('mini-cart');
    if (miniCart && typeof miniCart.updateSectionContents === 'function') {
      miniCart.updateSectionContents();
    }
  }

  var running = null;
  var again = false;

  function check() {
    if (running) {
      again = true;
      return running;
    }
    running = (async function () {
      var changed = false;
      for (var n = 0; n < 20; n++) {
        var res = await Promise.all([getCart(), getStock()]);
        var zone = (res[1].config && res[1].config.zona) || 'Europe/Paris';
        var change = nextChange(res[0], res[1], nowIn(zone));
        if (!change) break;
        await request(ROOT + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(change)
        });
        changed = true;
      }
      return changed;
    })()
      .catch(function (e) {
        log(e);
        return false;
      })
      .then(function (changed) {
        running = null;
        if (changed) refreshUI();
        if (again) {
          again = false;
          return check();
        }
        return changed;
      });
    return running;
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(check, 400);
  }

  // Detecta los cambios de carrito que hacen el tema y las apps.
  window.fetch = function (input, init) {
    var promise = nativeFetch(input, init);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var path = url.split('#')[0].split('?')[0];
      if (CART_RE.test(path)) {
        promise.then(schedule, function () {});
      }
    } catch (e) {
      log(e);
    }
    return promise;
  };

  // Antes de ir al checkout, asegura que el carrito esta corregido.
  document.addEventListener('click', function (ev) {
    var el = ev.target && ev.target.closest && ev.target.closest('[name="checkout"], a[href*="/checkout"]');
    if (!el || el.dataset.lioninoxOk) return;

    ev.preventDefault();
    ev.stopImmediatePropagation();
    goingToCheckout = true;

    var timeout = new Promise(function (resolve) { setTimeout(resolve, 4000); });
    Promise.race([check(), timeout]).then(function () {
      el.dataset.lioninoxOk = '1';
      if (el.tagName === 'A') {
        location.href = el.href;
        return;
      }
      var form = el.form || el.closest('form');
      if (form) {
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'checkout';
        hidden.value = '';
        form.appendChild(hidden);
        form.submit();
      } else {
        el.click();
      }
    });
  }, true);

  // Solo para pruebas desde la consola.
  window.__lioninoxPlazo = plazo;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();